// Personal salary-cap contest list storage (localStorage on the host's device).
// Shape: { [listName]: [{ name: string, salary: number }] }
const KEY = "pbo-contest-lists-v1";

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};

const write = (data) => {
  localStorage.setItem(KEY, JSON.stringify(data));
};

export const getContestLists = () => read();

export const getContestListNames = () =>
  Object.keys(read()).sort((a, b) => a.localeCompare(b));

export const getContestList = (name) => read()[name] || null;

export const saveContestList = (name, golfers) => {
  const trimmedName = String(name || "").trim();
  if (!trimmedName) throw new Error("List name required");
  const data = read();
  // Dedupe by name (case-insensitive), keep first occurrence
  const seen = new Set();
  const out = [];
  for (const g of golfers || []) {
    const nm = String(g?.name || "").trim();
    if (!nm) continue;
    const k = nm.toLowerCase();
    if (seen.has(k)) continue;
    seen.add(k);
    const sal = parseInt(g.salary, 10);
    out.push({ name: nm, salary: isNaN(sal) || sal < 0 ? 0 : sal });
  }
  data[trimmedName] = out;
  write(data);
};

export const renameContestList = (oldName, newName) => {
  const data = read();
  if (!data[oldName]) return false;
  if (oldName === newName) return true;
  if (data[newName]) return false;
  data[newName] = data[oldName];
  delete data[oldName];
  write(data);
  return true;
};

export const deleteContestList = (name) => {
  const data = read();
  delete data[name];
  write(data);
};

export const exportContestListsJson = () => JSON.stringify(read(), null, 2);

export const importContestListsJson = (json, { merge = true } = {}) => {
  let incoming;
  try {
    incoming = JSON.parse(json);
  } catch {
    throw new Error("Not valid JSON");
  }
  if (!incoming || typeof incoming !== "object" || Array.isArray(incoming)) {
    throw new Error("Expected an object of { listName: [{name, salary}, …] }");
  }
  for (const [k, v] of Object.entries(incoming)) {
    if (!Array.isArray(v))
      throw new Error(`List "${k}" must be an array`);
    for (const g of v) {
      if (!g || typeof g.name !== "string")
        throw new Error(`List "${k}" has an entry missing a name`);
    }
  }
  const current = merge ? read() : {};
  for (const [name, arr] of Object.entries(incoming)) {
    const seen = new Set();
    const out = [];
    for (const g of arr) {
      const nm = String(g.name || "").trim();
      if (!nm) continue;
      const k = nm.toLowerCase();
      if (seen.has(k)) continue;
      seen.add(k);
      const sal = parseInt(g.salary, 10);
      out.push({ name: nm, salary: isNaN(sal) || sal < 0 ? 0 : sal });
    }
    current[name.trim()] = out;
  }
  write(current);
};
